import { render, staticRenderFns } from "./WindowBoard.vue?vue&type=template&id=ca27848e&scoped=true&"
import script from "./WindowBoard.vue?vue&type=script&lang=js&"
export * from "./WindowBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca27848e",
  null
  
)

export default component.exports